import DashboardLayout from "../../../lib/components/layouts/dashboard";
import { PAGE_ROUTES } from "lib/constants/page-routes";
import { AppContext } from "lib/contexts/app-context";
import { useContext } from "react";
import SimpleCard from "lib/components/common/simple-card";
import { Col, Row } from "react-bootstrap";
import SimpleTextbox from "lib/components/common/simple-textbox";
import SimpleButton from "lib/components/common/simple-button";
import FlexBox from "lib/components/common/flex-box";
import useFormBinder from "lib/hooks/useFormBinder";
import useAuthentication from "lib/hooks/useAuthentication";
import { DEFAULT_PATIENT_INFO } from "lib/constants/default-values";
import {
  AGE_VALIDATION_SCHEMA,
  EMAIL_VALIDATION_SCHEMA,
  NAME_VALIDATION_SCHEMA,
  PASSWORD_VALIDATION_SCHEMA,
  PHONE_NUMBER_VALIDATION_SCHEMA,
  POSTCODE_VALIDATION_SCHEMA,
} from "lib/constants/validation-constants";
import usePatients from "lib/hooks/usePatients";
import { toast } from "sonner";

const breadcrumbItems: BreadcrumbItem[] = [
  {
    label: "Invite Patient For Booking",
    path: PAGE_ROUTES.ADMIN.BookAppointment,
  },
];

const AdminAddAppointmentPage = () => {
  const { values, handleChange, setValues } =
    useFormBinder(DEFAULT_PATIENT_INFO);
  const {
    signupPatient,
    loading: patientsLoading,
    error: patientsError,
  } = usePatients();

  const handleSignUp = () => {
    signupPatient(values, (patient) => {
      toast.success(`${values.name} invited successfully!`);
      setValues(DEFAULT_PATIENT_INFO);
    });
  };

  return (
    <DashboardLayout
      breadcrumbItems={breadcrumbItems}
      //isUnavailable={practitionerSubscriptionState.status === "success"}
    >
      <Row className="justify-content-md-center">
        <Col sm="6">
          <SimpleCard
            title="Enter patient details"
            footer={
              <FlexBox justifyContent="end">
                <SimpleButton
                  isLoading={patientsLoading}
                  onClick={handleSignUp}
                >
                  Send invite
                </SimpleButton>
              </FlexBox>
            }
            isLoading={patientsLoading}
            error={patientsError}
          >
            <SimpleTextbox
              name="name"
              label="Patient Name"
              value={values.name}
              required
              onChange={handleChange}
              validationSchema={NAME_VALIDATION_SCHEMA()}
            />
            <SimpleTextbox
              name="email"
              label="Patient Email"
              className="mt-3"
              value={values.email}
              required
              onChange={handleChange}
              validationSchema={EMAIL_VALIDATION_SCHEMA}
            />
            {/* <Row>
              <Col sm="6">
                <SimpleTextbox
                  name="age"
                  label="Patient's Age"
                  className="mt-3"
                  value={values.age}
                  type="number"
                  required
                  onChange={handleChange}
                  validationSchema={AGE_VALIDATION_SCHEMA}
                />
              </Col>
              <Col sm="6"> */}
                <SimpleTextbox
                  name="phone"
                  label="Patient Phone"
                  className="mt-3"
                  value={values.phone}
                  required
                  onChange={handleChange}
                  validationSchema={PHONE_NUMBER_VALIDATION_SCHEMA}
                />
              {/* </Col>
            </Row>
            <SimpleTextbox
              name="postcode"
              label="Patient's Postcode"
              className="mt-3"
              value={values.postcode}
              required
              onChange={handleChange}
              validationSchema={POSTCODE_VALIDATION_SCHEMA}
            /> */}
          </SimpleCard>
        </Col>
      </Row>
    </DashboardLayout>
  );
};

export default AdminAddAppointmentPage;
